import React, { useContext } from 'react';
import { TableLayoutContext } from '../../layout-context';
import { TableHeadCell } from '../head-cell';
import { TableHeadRow } from '../head-row';
import { StyledHead } from './styled';
import { TableToolbar } from './toolbar';
const tableHeadRenderMap = {
    table: ({ children, ...props }) => (React.createElement(StyledHead, { ...props }, children)),
    block: ({ children, ...props }) => (React.createElement(StyledHead, { as: "div", role: "rowgroup", "aria-label": "header", className: "header", "$isBlock": true, ...props }, children))
};
const TableHeadLayout = ({ children, layoutType }) => {
    const renderHead = tableHeadRenderMap[layoutType];
    return renderHead({ children });
};
export const TableHead = ({ headerGroups, actions, selectedRowIds, selectedFlatRows, props }) => {
    const layoutType = useContext(TableLayoutContext);
    return (React.createElement(TableHeadLayout, { layoutType: layoutType },
        actions && actions.length && (React.createElement(TableToolbar, { layoutType: layoutType, actions: actions, selectedRowIds: selectedRowIds, selectedFlatRows: selectedFlatRows })),
        headerGroups.map((headerGroup, index) => {
            const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
            return (React.createElement(TableHeadRow, { key: key, ...headerGroupProps }, headerGroup.headers.map((column) => {
                const { key, ...headerProps } = column.getHeaderProps();
                return (React.createElement(TableHeadCell, { key: key, lineIndex: index, topBorder: Boolean(actions), column: column, ...headerProps, additionalProps: props }));
            })));
        })));
};
TableHead.displayName = 'TableHead';
